export default "__VITE_ASSET__zZ4Vyz3H__"